// extracted by mini-css-extract-plugin
export default {"tableWrapper":"HotWalletsTableView_tableWrapper__7YOvG"};